import script from "./AuthorizationLoginView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationLoginView.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationLoginView.vue?vue&type=style&index=0&id=e3978ccc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3978ccc"]])

export default __exports__